import { useLayoutEffect } from 'react';

// The authenticated app scrolls its outlet, not the document body.
export default function usePageScrollLock(active) {
  useLayoutEffect(() => {
    if (!active) return undefined;
    const page = document.querySelector('[data-app-scroll]') || document.body;
    const overflow = page.style.overflowY;
    page.style.overflowY = 'hidden';
    return () => { page.style.overflowY = overflow; };
  }, [active]);
}
